import { c as _c } from "react/compiler-runtime";
import { format } from 'date-fns';
type DateTimeProps = {
  timestamp: string;
};
const DateTime = t0 => {
  const $ = _c(11);
  const {
    timestamp
  } = t0;
  let t1;
  if ($[0] !== timestamp) {
    t1 = format(new Date(timestamp), "MM/dd/yy");
    $[0] = timestamp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h4 className="text-snippet-2 text-tertiary w-[72px]">{t1}</h4>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== timestamp) {
    t3 = format(new Date(timestamp), "h:mm a");
    $[4] = timestamp;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <h4 className="text-snippet-2 text-tertiary w-[68px]">{t3}</h4>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="flex gap-2">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default DateTime;